import axios from 'axios';
import CONFIG from '../config';

let _activeWorkspaceId = null;
let _activeFiscalYearId = null;

export const setActiveWorkspaceId = (id) => {
  _activeWorkspaceId = id;
};

export const setActiveFiscalYearId = (id) => {
  _activeFiscalYearId = id;
};

const api = axios.create({
  baseURL: CONFIG.API_URL,
  withCredentials: false,
  timeout: 60000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  const workspaceId = _activeWorkspaceId || (() => {
    try { return localStorage.getItem('active_workspace_id') || null; } catch { return null; }
  })();
  if (workspaceId) {
    config.headers['x-workspace-id'] = workspaceId;
  }

  const fiscalYearId = _activeFiscalYearId || (() => {
    try { return localStorage.getItem('current_fiscal_year_id') || null; } catch { return null; }
  })();
  if (fiscalYearId) {
    config.headers['x-fiscal-year-id'] = fiscalYearId;
  }

  return config;
});

export default api;
